import { Component, OnInit,ViewChild, ElementRef} from '@angular/core';
import {BsLocaleService,BsDatepickerConfig,BsDatepickerViewMode } from 'ngx-bootstrap/datepicker';
import {Router,ActivatedRoute} from '@angular/router';
import {HttpClient,HttpErrorResponse,HttpHeaders,HttpParams} from '@angular/common/http';
import { fromEvent } from 'rxjs';
import {getdate} from '../../formatfunction' ;
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import * as Highmaps from 'highcharts/highmaps';


declare var require:any;
declare var echarts:any;
let nodata = require('highcharts/modules/no-data-to-display')
let drilldown = require('highcharts/modules/drilldown')
nodata(Highcharts)
drilldown(Highmaps)
let funnel = require('highcharts/modules/funnel')
funnel(Highcharts)

@Component({
  selector: 'app-static-shopify',
  templateUrl: './static-shopify.component.html',
  styleUrls: ['./static-shopify.component.css']
})
export class StaticShopifyComponent implements OnInit {

  	language;

	constructor(private router: Router,
        private http:HttpClient,
        private route: ActivatedRoute,
        private el: ElementRef,
        public translate: TranslateService,) 
	{
		translate.addLangs(["zh", "en","fr"]);
        translate.setDefaultLang('zh');

        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(/(zh|en|fr)/) ? browserLang : 'zh');
        this.language = browserLang.match(/(zh|en|fr)/) ? browserLang : 'zh'
     
        this.app = {
            layout: {
                themeConfigOpen: false
            }
        };  

	}

	public app : any;
    

	bsConfig: Partial<BsDatepickerConfig>;
	daterangepickerModel;

	current=1;content='order'
	last='2022-05-30'
	marketing_type='tbk'
	platSelectOptions=[{'label':'TMALL','value':'TMALL'},{'label':'JD','value':'JD'}]
	
	changelanguage(){
        this.translate.use(this.language)
    }

	selectPlatform=['TMALL']
	top10province=[
		{sale: 9886.92, state: "广东省", order: 33},
		 {sale: 5992.33, state: "浙江省", order: 31},
		 {sale: 5286.34, state: "福建省", order: 14},
		 {sale: 2852.01, state: "江苏省", order: 20},
		 {sale: 2582.97, state: "北京", order: 15},
		 {sale: 2514.62, state: "四川省", order: 10},
		 {sale: 1924.29, state: "上海", order: 9},
		 {sale: 849.64, state: "辽宁省", order: 4},
		 {sale: 724.49, state: "河南省", order: 4},
		 {sale: 702.44, state: "河北省", order: 6}
				
	]

	chargeData=[
		{
			'name':'充值',
			'price':'50',
			'status':'active',
			'created':'2022-05-20',
		},
		{
			'name':'充值',
			'price':'100',
			'status':'pending',
			'created':'2022-05-20',
		}
	]
	ngOnInit() {
		if (this.content=='order'){
	        this.current =0 
	    }
        else if (this.content=='market'){
	        this.current =1
	    }
	    else if (this.content=='charge'){
	        this.current =2
	    }else{
	    	return this.router.navigate(['/invalidpage'])
	    }


	    this.bsConfig = Object.assign({}, {showWeekNumbers:false,containerClass: 'theme-blue'});
   
        var today = new Date()
        var nowMonth = today.getMonth(); //当前月 
	    var nowYear = today.getFullYear(); //当前年 
	    //本月的开始时间
	    var monthStartDate = new Date(nowYear, nowMonth, 1); 
        this.daterangepickerModel = [monthStartDate,today]

        
	}

	ngAfterViewInit(){
		this.createstack()
        this.createpie('todaychart')
        this.createpie('weekchart')
        this.createpie('monthchart')
        this.createpie('yearchart')
        this.createchart('thisweekperday')
        this.createchart('lastweekperday')
        this.createchart('thismonthperday')
        this.createchart('lastmonthperday')
        this.createchart('thisyearpermonth')
        this.createchart('lastyearpermonth')

        var mapdata = [{sale: 9886.92, state: "广东省", order: 33},
         {sale: 5992.33, state: "浙江省", order: 31},
         {sale: 5286.34, state: "福建省", order: 14},
         {sale: 2852.01, state: "江苏省", order: 20},
         {sale: 2582.97, state: "北京", order: 15},
         {sale: 2514.62, state: "四川省", order: 10},
         {sale: 1924.29, state: "上海", order: 9},
         {sale: 849.64, state: "辽宁省", order: 4},
         {sale: 724.49, state: "河南省", order: 4},
         {sale: 702.44, state: "河北省", order: 6}]
        var data = require('../../../assets/datas/salemap.json')
        var areadata = data['features']
        for(let p of areadata){
            p['properties']['sale'] =0
            p['properties']['order'] =0
            p['properties']['uv'] =0
            p['properties']['percentage'] = 0
            for(let i of mapdata){
                if (p['properties']['fullname']==i['state'] || p['properties']['name']==i['state']){
                    p['properties']['sale'] += i['sale']
                    p['properties']['order'] += i['order']
                    p['properties']['uv'] += i['uv']

                   
                }
            }
               
            
            p['properties']['percentage'] = p['properties']['sale']/38962.86
        }

        this.createmap(data)
	}

	changetab = function(id){
        if (id=='order'){
            this.content = 'order'
            
        }
        else if (id=='market'){
	       this.content = 'market'
	       this.changeMarketing('tbk')
	    }
	    else if (id=='charge'){
	        this.content = 'charge'
	    }
    
    }


	changeMarketing(type){
		this.marketing_type = type
		this.createcolumn()
		this.createfunnel()

	}

	createpie = function(div){
        Highcharts.setOptions({lang: {noData:'NO DATA'}});
        
        var pie = Highcharts.chart(div,{
            chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie'
            },
            title: {
                floating:true,
                text: null,
                

            },
            loading: {
                    hideDuration: 1000,
                    showDuration: 1000
            }, 
            credits: {
              enabled: false
            },
            tooltip: {
                formatter:function(){
                    var s ;
                    s = 'NAME:'+this.point.name+'<br/>SALES:<b>￥'+("" + (+this.y.toFixed(2))).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")+'</b><br> <b>'+(this.point.percentage).toFixed(2)+'%</b>';
                        
                    return s;
                },
            },
            colors: ["#ef9a9a","#F48FB1","#CE93D8","#B39DDB","#9FA8DA","#90CAF9",
                "#81D4FA","#80DEEA","#80CBC4","#A5D6A7","#C5E1A5","#E6EE9C",
                "#FFF59D","#FFE082","#FFCC80","#FFAB91","#BCAAA4","#EEEEEE",
                "#B0BEC5","#e57373","#F06292","#BA68C8","#9575CD","#7986CB",
                "#64B5F6","#4FC3F7","#4DD0E1","#4DB6AC","#81C784","#AED581",
                "#DCE775","#FFF176","#FFD54F","#FFB74D","#FF8A65","#A1887F",
                "#E0E0E0","#90A4AE"],
            plotOptions: {
                        pie: {
                            innerSize: '80%',
                            size:"80%",
                            allowPointSelect: true,
                            cursor: 'pointer',
                            showInLegend: false,
                            dataLabels: {
                                enabled: true,
                                formatter:function(){
                                    var s ;
                                    s = this.point.name +' '
                                    +(this.point.percentage).toFixed(2)+'%' + ' ￥'+ ("" + (+this.y.toFixed(2))).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
                                        
                                    return s;
                                }  
                            }
                        }
                },
                legend:{
                    useHTML:true,
                    align: 'left',
                    verticalAlign: 'bottom',
                    maxHeight:80
                },
                series: [{data: [{name: "TMALL GLOBAL", y: 960.8}, {name: "JD GLOBAL", y: 10.8}], type: 'pie'}]
        });
        return pie
    }

	createcolumn = function(){        
        Highcharts.setOptions({ global: { useUTC: false } ,lang: {thousandsSep: ',',noData:''}});      
        var chart = Highcharts.chart('roichart',{
			exporting:{
				enabled: false
			},
			credits: {
                enabled: false
            },
			title: {
				text: null
			},
			xAxis: {
				type:"datetime",
				labels:{
					format:'{value:%Y-%m-%d}'
				},
				showFirstLabel:true,
				showLastLabel:true
			},
			yAxis: [{
				min: 0,
				title: {
					text: 'COST(RMB)'
				}
			}, {
				title: {
					text: 'PAYMENT(RMB)'
				},
				opposite: true
			}, {
				title: {
					text: 'ROI'
				},
				opposite: true
			}],
			legend: {
				shadow: false
			},
			tooltip: {
				shared: true
			},
			plotOptions: {
				column: {
					grouping: false,
					shadow: false,
					borderWidth: 0
				}
			},
			series: [{"pointPlacement": 0, "tooltip": {"valuePrefix": "\uffe5"}, "name": "PAYMENT", "data": [{"x": 1651334400000, "y": 1570.86}, {"x": 1651420800000, "y": 7620.94}, {"x": 1651507200000, "y": 3304.63}, {"x": 1651593600000, "y": 2963.11}, {"x": 1651680000000, "y": 5513.7}, {"x": 1651766400000, "y": 4629.78}, {"x": 1651852800000, "y": 4040.22}, {"x": 1651939200000, "y": 1831.53}, {"x": 1652025600000, "y": 1267.23}, {"x": 1652112000000, "y": 3708.06}, {"x": 1652198400000, "y": 4158.45}, {"x": 1652284800000, "y": 3064.78}, {"x": 1652371200000, "y": 5303.78}, {"x": 1652457600000, "y": 2966.65}, {"x": 1652544000000, "y": 5312.07}, {"x": 1652630400000, "y": 1344.7}, {"x": 1652716800000, "y": 3193.14}, {"x": 1652803200000, "y": 1400.93}, {"x": 1652889600000, "y": 1277.0}, {"x": 1652976000000, "y": 3039.12}, {"x": 1653062400000, "y": 3165.06}, {"x": 1653148800000, "y": 6529.06}, {"x": 1653235200000, "y": 454.56}, {"x": 1653321600000, "y": 2588.77}], "yAxis": 0, "color": "rgba(165,170,217,1)", "pointPadding": -0.1, "type": "column"}, {"pointPlacement": 0, "tooltip": {"valuePrefix": "\uffe5"}, "name": "COST", "data": [{"x": 1651334400000, "y": 47.1}, {"x": 1651420800000, "y": 165.87}, {"x": 1651507200000, "y": 132.41}, {"x": 1651593600000, "y": 89.91}, {"x": 1651680000000, "y": 178.1}, {"x": 1651766400000, "y": 149.02}, {"x": 1651852800000, "y": 141.33}, {"x": 1651939200000, "y": 51.83}, {"x": 1652025600000, "y": 37.84}, {"x": 1652112000000, "y": 111.24}, {"x": 1652198400000, "y": 124.75}, {"x": 1652284800000, "y": 90.78}, {"x": 1652371200000, "y": 182.51}, {"x": 1652457600000, "y": 82.02}, {"x": 1652544000000, "y": 159.35}, {"x": 1652630400000, "y": 50.18}, {"x": 1652716800000, "y": 98.94}, {"x": 1652803200000, "y": 37.16}, {"x": 1652889600000, "y": 38.13}, {"x": 1652976000000, "y": 90.82}, {"x": 1653062400000, "y": 98.76}, {"x": 1653148800000, "y": 308.7}, {"x": 1653235200000, "y": 9.37}, {"x": 1653321600000, "y": 64.63}], "yAxis": 0, "color": "rgba(126,86,134,.7)", "pointPadding": 0, "type": "column"}, {"dataLabels": {"enabled": true}, "name": "ROI", "yAxis": 2, "data": [{"x": 1651334400000, "y": 33.35}, {"x": 1651420800000, "y": 45.95}, {"x": 1651507200000, "y": 24.96}, {"x": 1651593600000, "y": 32.96}, {"x": 1651680000000, "y": 30.96}, {"x": 1651766400000, "y": 31.07}, {"x": 1651852800000, "y": 28.59}, {"x": 1651939200000, "y": 35.34}, {"x": 1652025600000, "y": 33.49}, {"x": 1652112000000, "y": 33.33}, {"x": 1652198400000, "y": 33.33}, {"x": 1652284800000, "y": 33.76}, {"x": 1652371200000, "y": 29.06}, {"x": 1652457600000, "y": 36.17}, {"x": 1652544000000, "y": 33.34}, {"x": 1652630400000, "y": 26.8}, {"x": 1652716800000, "y": 32.27}, {"x": 1652803200000, "y": 37.7}, {"x": 1652889600000, "y": 33.49}, {"x": 1652976000000, "y": 33.46}, {"x": 1653062400000, "y": 32.05}, {"x": 1653148800000, "y": 21.15}, {"x": 1653235200000, "y": 48.51}, {"x": 1653321600000, "y": 40.06}], "type": "spline"}]
        });
          
        return chart

    }

    createfunnel(){
    	var chart = Highcharts.chart('convert',{
            chart: {
				type: 'funnel',
				marginRight: 100,
				marginLeft: 100
			},
			exporting:{
				enabled: false
			},
			credits: {
                enabled: false
            },
			title: {
				text:null
			},
			plotOptions: {
				funnel: {
					dataLabels: {
						enabled: true,
						format: '<b>{point.name}</b> ({point.y:,.0f})'
					},
					neckWidth: '30%',
					neckHeight: '25%'
				}
			},
			legend: {
				enabled: false
			},
			series:[{"data": [["NUMBER OF CLICK", 4205], ["NUMBER OF COMPLETED ORDERS", 377]],
			type: 'funnel'}]
        });
          
        return chart
    }


    createstack = function(){        
        Highcharts.setOptions({ global: { useUTC: false } ,lang: {thousandsSep: ',',noData:''}});      
        var chart = Highcharts.chart('salesperhour',{
            chart: {
                type: 'column'
            },
            loading: {
                hideDuration: 1000,
                showDuration: 1000
            },               
            legend:{
                enabled:false
            },
            credits: {
                enabled: false
            },
            series: [{"data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 130.92, 0, 0, 0, 0, 0, 10.8, 0, 0, 0, 0, 32.4],  "color": "#F2BBBB", "market": "TMALL", "name": '1653408000000',type: 'column'}, {"data": [179.0, 0, 0, 0, 0, 0, 0, 0, 0, 139.0, 0, 0, 0, 0, 109.0, 179.0, 139.0, 0, 0, 0, 0, 109.0, 0, 0], "color": "#D90416", "market": "TMALL", "name": '1652630400000',type: 'column'}, {"data": [0, 0, 0, 109.0, 0, 0, 228.0, 139.0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "color": "#F2B9B3", "market": "TMALL", "name": '1652716800000',type: 'column'}, {"data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 139.0, 0, 0, 0, 368.0, 179.0, 0, 0, 0, 0, 0, 0, 0], "color": "#D92525", "market": "TMALL", "name": '1653148800000',type: 'column'}, {"data": [0, 370.45, 0, 0, 0, 0, 0, 0, 0, 299.79, 0, 0, 85.2, 0, 0, 241.83, 0, 0, 0, 0, 85.2, 0, 265.45, 0], "color": "#F25757", "market": "TMALL", "name": '1651507200000',type: 'column'}, {"data": [0, 0, 0, 0, 0, 0, 0, 207.75, 0, 0, 0, 0, 255.49, 89.0, 0, 0, 0, 0, 147.52, 0, 170.25, 0, 0, 0], "color": "#D94141", "market": "TMALL", "name": '1652889600000',type: 'column'}],

            xAxis: {
                categories: ['00', '01', '02', '03', '04','05', '06', '07', '08', '09','10', '11', '12', '13', '14','15', '16', '17', '18', '19','20','21','22','23']
            },
            colors:['#D90416',
            '#F2B9B3',
            '#BF0404',
            '#D94141',
            '#F28D8D',
            '#F2A594',
            '#D92525',
            '#F25757',
            '#F28585',
            '#F2BBBB'],
            
            plotOptions: {
                column: {
                    stacking: 'normal'
                },
                series: {
                    borderWidth: 0
                }
            },
            title: null,
            yAxis: {
                title: null,
                gridLineWidth:0,
                lineWidth:2
            },
            tooltip: {
                shared: true,
                useHTML:true,
                borderWidth: 0,
                formatter:function(){
                    function compare(property){
                        return function(a,b){
                            var value1 = a[property];
                            var value2 = b[property];
                            return value2-value1
                        }
                    }
                    var total=0;
                    $.each(this.points ,function(){
                        total+=this.y;
                    });
                    var s = '<h5 style="border-bottom:1px solid #e6ecf5;"><b>'+this.x+':00</b></h5>';
                    var count = 0
                    s+='<div style="display:inline-grid;">'
                    var point = this.points.sort(compare('y')).slice(0,5)
                    $.each( point,function(){
                        var name = parseInt(this.series.name)
                        s += '<span><span style="color:'+this.color+';font-size:14px;font-weight:bold">●'+
                        (new Date(name).getMonth()+1)+'/'+new Date(name).getDate() +':</span>￥'+
                        ("" + (+this.y.toFixed(2))).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")+'</span>';
                        count+=1
                        if (count%5==0 || count==point.length){
                            s+='</div>'
                            if (count!=point.length){
                                s+='<div style="display:inline-grid;">'
                            }
                        }
                    });
                    s+= '<div><h5><b>TOTAL:￥'+("" + (+total.toFixed(2))).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")+'</b></h5></div>';
                    return s;
                },

            }
        });
          
        return chart

    }

    createchart = function(div){     

        Highcharts.setOptions({ 
            global: { useUTC: false } ,
            lang: {thousandsSep: ',',noData:'NO DATA'}
        }); 

        var chart = Highcharts.chart(div,{
            chart: {
                type: 'column'
            },
            loading: {
                hideDuration: 1000,
                showDuration: 1000,

            },           
            legend:{
                enabled:false
            },
            credits: {
                enabled: false
            },
            series: [{type: 'column',data: [{y: 1000, name: '0', x: 1653235200000,}, {y: 2463, name: '0', x: 1653321600000}]}],
            colors: ['#f48fb1','#ef9a9a','#ce93d8','#b39ddb','#9fa8da','#90caf9','#81d4fa',
            '#80deea','#80cbc4','#a5d6a7'],
            xAxis: {
                type:"datetime",
                labels:{
                    format:"{value:%m-%d}" ,
                    step:1
                },
                showFirstLabel:true,
                showLastLabel:true
            },
            plotOptions: {
                column: {
                    stacking: 'normal'
                },
                series: {
                    borderWidth: 0
                }
            },
            tooltip: {
                useHTML:true,
                formatter:function(){
                    var date = new Date(this.x)
                    var s =date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate() +'<br/>';
                    s+='<div style="display:inline-grid;">'
                    var count = 0

                    $.each(this.points,function(){
                        s +='<b>'+this.series.name.toUpperCase()+' SALE:￥'+("" + (+this.y.toFixed(2))).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")+'</b>'+
                        '<b>'+this.series.name.toUpperCase()+' ORDER:'+("" + (+(+this.point.name).toFixed(2))).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")+'</b>'
                        count+=1
                        if (count%8==0 || count==this.point.length){
                            s+='</div>'
                            if (count!=this.point.length){
                                s+='<div style="display:inline-grid;">'
                            }
                        }
                    })
                    return s;
                },
                shared:true
            },
            title: null,
            yAxis: {
                title: null,
                gridLineWidth:0,
                lineWidth:2
            },
            noData: {
                style: {
                    fontWeight: 'bold',
                    fontSize: '15px'
                }
            }
        });


        
        return chart
    }

    createmap = function(mapdata) { 
        var data = []
        function compare(property){
            return function(a,b){
                var value1 = a['properties'][property];
                var value2 = b['properties'][property];
                return value2-value1
            }
        }
        // 随机数据
        var colors = ['#1A237E','#283592','#0D47A1','#303f9f','#01579B','#1565C0','#0177bd','#0277BD','#1976ce',
        '#0288D1','#1976D2','#0288e1','#1E88E5','#2096fb','#049be5','#2096f4','#05a9f4','#039BE5',
        '#2196F3','#03A9F4','#42A5F5','#02b0ff','#2ab6f6','#29B6F6','#64B5F6','#4FC3F7','#4ec3f7',
        '#3fc4ff','#90CAF9','#8fcaf9','#81D4FA','#7fd8ff','#BBDEFB','#B3E5FC','#E3F2FD','#E1F5FE',
        ]
        Highmaps.each(mapdata.features.sort(compare('percentage')), function(md, index) {
            var color
            var tmp

            if(md.properties.percentage==0){
                tmp= {
                    name: md.properties.name,
                    color: '#E1F5FE'
                }

            }else if (index<10){
                tmp= {
                    name: md.properties.name,
                    color:colors[index]

                }
                
            }else{


                var m = 11
                for (let i = 1; i >0; i=i-0.05) {
                    i=+i.toFixed(2)
                    if(md.properties.percentage>(+(i-0.05).toFixed(2)) && md.properties.percentage<=i){
                        color = colors[m]
                    }
                    m=m+1
                }
                tmp= {
                    name: md.properties.name,
                    color:color

                }
            }
            if(md.properties.drilldown) {
                tmp.drilldown = md.properties.drilldown;
            }


            data.unshift(tmp);
        });
        var that = this
        this.map = Highmaps.mapChart('map',{
            chart:{
                type:'map'
            },

            title: {
                text: null
            },
            credits: {
                enabled: false
            },
            mapNavigation: {
                enabled: false,
                buttonOptions: {
                    verticalAlign: 'bottom'
                }
            },

            legend: {
                enabled:false
            },
            tooltip: {
                useHTML: true,
                formatter:function(){
                    var s 
                    var en_name = this.point.properties.Englishname || this.point.properties.filename
                    s = this.point.properties.fullname+'/'+ en_name+'<br/>'+
                    'TOTAL SALE:￥'+("" + this.point.properties.sale).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")+'<br/>'+
                    'TOTAL ORDER:'+("" + this.point.properties.order).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")+'<br/>'+
                    // "UV:"+("" + this.point.properties.uv).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")+'<br/>'+
                    "PERCENTAGE:"+(this.point.properties.percentage*100).toFixed(2)+"%"

                    return s
                }


            },

            series: [{
            	type:'map',
                data: data,
                mapData: mapdata,
                joinBy: 'name',
                name: null,
                states: {
                    hover: {
                        color: '#a4edba'
                    }
                }
            }],

        });
    
    };
}
